import { KalturaMultilingualStringValueArray, KalturaValue } from '@kaltura-ott/ott-client-types/api/types';

export interface KalturaCategoryTags {
  [key: string]: KalturaMultilingualStringValueArray;
}

export interface KalturaMetas {
  [key: string]: KalturaValue;
}

export interface KuxCategoryTags {
  [key: string]: string | string[];
}

export const normalizeCategoryTags = (tags: KalturaCategoryTags): KuxCategoryTags => {
  const normalizedMeta: KuxCategoryTags = {};

  Object.keys(tags).forEach(
    (key) =>
      (normalizedMeta[key] =
        tags[key].objects.length === 1 ? tags[key].objects[0].value : tags[key].objects.map(({ value }) => value)),
  );
  return normalizedMeta;
};
